import { Injectable } from '@angular/core';
import { GfTranslateService } from '../../../core/services/core.translate.service';
import { UserService } from '../../../core/services/core.user.service';
import * as _ from 'lodash';

@Injectable()
export class TrackerAclsService {
    acls: any;

    constructor(
        private userService: UserService, 
        private gfTranslateService: GfTranslateService) {
    }

    private getDefaultAcls() {
        return {
            canRead: false,
            canSubmit: false,
            canUpdate: false,
            canAssign: false,
            isAdmin: false
        };
    }

    public get(tracker_permissions, tracker_id) {
        var defaults = this.getDefaultAcls();
        return Object.assign(
            defaults,
            _.pick(_.get(tracker_permissions, tracker_id, {}), Object.keys(defaults))  // override defaults with found values
        );
    }

    public set(acls) {
        this.acls = _.cloneDeep(acls);
    }

    public canRead(tracker) {
        return (_.has(this.acls, tracker.id) ? 
            this.acls[tracker.id].canRead : 
            (_.has(this.acls, tracker.tracker_id) ? this.acls[tracker.tracker_id].canRead : false));
    }

    public canSubmit(tracker) {
        return (_.has(this.acls, tracker.id) ? 
            this.acls[tracker.id].canSubmit : 
            (_.has(this.acls, tracker.tracker_id) ? this.acls[tracker.tracker_id].canSubmit : false));
    }

    public canUpdate(tracker) {
        return (_.has(this.acls, tracker.id) ? 
            this.acls[tracker.id].canUpdate : 
            (_.has(this.acls, tracker.tracker_id) ? this.acls[tracker.tracker_id].canUpdate : false));
    }

    public canAssign(tracker) {
        return (_.has(this.acls, tracker.id) ?
            this.acls[tracker.id].canAssign :
            (_.has(this.acls, tracker.tracker_id) ? this.acls[tracker.tracker_id].canAssign : false));
    }

    public isAdmin(tracker) {
        return (_.has(this.acls, tracker.id) ? 
            this.acls[tracker.id].isAdmin : 
            (_.has(this.acls, tracker.tracker_id) ? this.acls[tracker.tracker_id].isAdmin : false));
    }

    /**
     * Returns a promise that resolves or rejects based on the value of the flag parameter.
     * ToDo: Maybe move this to a common service?
     */
    public assertPermission(flagValue: boolean) {
        if (flagValue) {
            return Promise.resolve(true);
        } else {
            if (this.userService.session.hasUser()) {
                return Promise.reject({ status: 403, data: this.gfTranslateService.translate('Forbidden') });
            } else {
                return Promise.reject({ status: 401, data: this.gfTranslateService.translate('Not Authorized') });
            }
        }
    }
}